import * as Models from "../.";
export interface ILoginResponse {
  isSuccessful: boolean;
  user: Models.UserModel.IUserModel;
  isLocked: boolean;
}

export class LoginResponse implements ILoginResponse {
  isSuccessful: boolean;
  user: Models.UserModel.IUserModel;
  isLocked: boolean;
}
